import { cn } from "@util/helpers";

type NewsletterTitleProps = {
  title: string;
  formattedTitle: string;
  sectionRef: React.RefObject<HTMLDivElement>;
  rootClassname?: string;
};

const NewsletterTitle = ({
  title,
  formattedTitle,
  sectionRef,
  rootClassname,
}: NewsletterTitleProps): React.ReactElement => {
  return (
    <h5
      className={cn(
        "mb-5 border-t border-gray-850 pt-3 font-poppins text-lg uppercase text-gray-850 lg:border-none",
        rootClassname
      )}
      id={formattedTitle}
      ref={sectionRef}
    >
      {title}
    </h5>
  );
};

export default NewsletterTitle;
